/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

import { notaryAPI } from '../../../api/notary';
import { setSigningAction } from '../../../actions/signingRoomActions';
import { participantAPI } from '../../../api/participant';
import { useInterval } from '../../../hooks/useInterval';
import { useRootSelector } from '../../../hooks/useRootSelector';
import { isNotaryRoute } from '@utils/routing';
import { isEqual } from '@utils/lodash';

const ACTION_REFRESH_INTERVAL = 3000;

export const usePollSigningAction = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isNotary = isNotaryRoute(location.pathname);
  const { signingRoom, callDetails } = useRootSelector(state => state);
  const { signingAction } = signingRoom;

  const fetchSigningAction = async () => {
    try {
      if (!!callDetails?.id) {
        const action = isNotary
          ? await notaryAPI.documents.fetchAction(callDetails.id)
          : await participantAPI.documents.fetchActionForSession(callDetails.id);
        if (!isEqual(signingAction, action)) {
          setSigningAction(action)(dispatch);
        }
      }
    } catch (e) {
      throw e;
    }
  };

  useInterval(fetchSigningAction, ACTION_REFRESH_INTERVAL);
};
